export const RE_INITIALIZE_ON_EMBED_ADD = true;